import { dateColumnSort } from '@/utils/table';
import { DateTime } from 'luxon';

const MAX_ORDER_DOWNLOAD_DAY_RANGE = 31;

export const isWithinOneMonth = ({ startDate, endDate }: { startDate: Date; endDate: Date }) => {
  const date1 = DateTime.fromJSDate(startDate);
  const date2 = DateTime.fromJSDate(endDate);

  const diffInDays = Math.abs(date1.diff(date2, 'days').days);

  return diffInDays <= MAX_ORDER_DOWNLOAD_DAY_RANGE;
};

export const sortFieldOverrides = {
  patient_name: 'Patient.PatientUser.first_name',
  gp_name: 'GeneralPractitioner.Doctor.first_name',
} as const;

export const sortDispenseDate = (dateA: string, dateB: string) => {
  if (dateA === '-') {
    return -1;
  }
  return dateColumnSort(dateA, dateB);
};
